/**
 * トグルブロック
 * @module toggleBlock
 * @param {string} className - トグルボタンのクラス名
 * @description トグルボタンをクリックすると、次の要素をスライドアップまたはスライドダウンします。
*/

export function toggleBlock(className = 'js-toggle') {
	// トグルボタンの取得
	const toggleButtons = Array.from(document.getElementsByClassName(className));

	// コンテンツ非表示アニメーション
	const slideUp = (el, duration = 300) => {
		el.style.height = el.offsetHeight + "px";
		el.offsetHeight;
		el.style.transitionProperty = "height, margin, padding";
		el.style.transitionDuration = duration + "ms";
		el.style.transitionTimingFunction = "ease";
		el.style.overflow = "hidden";
		el.style.height = 0;
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
		el.style.marginTop = 0;
		el.style.marginBottom = 0;
		setTimeout(() => {
			el.style.display = "none";
			el.style.removeProperty("height");
			el.style.removeProperty("padding-top");
			el.style.removeProperty("padding-bottom");
			el.style.removeProperty("margin-top");
			el.style.removeProperty("margin-bottom");
			el.style.removeProperty("overflow");
			el.style.removeProperty("transition-duration");
			el.style.removeProperty("transition-property");
			el.style.removeProperty("transition-timing-function");
		}, duration);
	};

	// コンテンツ表示アニメーション
	const slideDown = (el, duration = 300) => {
		el.style.removeProperty("display");
		let display = window.getComputedStyle(el).display;
		if (display === "none") {
			display = "block";
		}
		el.style.display = display;
		let height = el.offsetHeight;
		el.style.overflow = "hidden";
		el.style.height = 0;
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
		el.style.marginTop = 0;
		el.style.marginBottom = 0;
		el.offsetHeight;
		el.style.transitionProperty = "height, margin, padding";
		el.style.transitionDuration = duration + "ms";
		el.style.transitionTimingFunction = "ease";
		el.style.height = height + "px";
		el.style.removeProperty("padding-top");
		el.style.removeProperty("padding-bottom");
		el.style.removeProperty("margin-top");
		el.style.removeProperty("margin-bottom");
		setTimeout(() => {
			el.style.removeProperty("height");
			el.style.removeProperty("overflow");
			el.style.removeProperty("transition-duration");
			el.style.removeProperty("transition-property");
			el.style.removeProperty("transition-timing-function");
		}, duration);
	};
	if (toggleButtons.length) {
		toggleButtons.forEach(toggleButton => {
			toggleButton.addEventListener('click', () => {
				const toggleContent = toggleButton.nextElementSibling;
				if (toggleContent.style.display === 'block') {
					slideUp(toggleContent, 300);
					toggleButton.classList.remove('active');
				} else {
					slideDown(toggleContent, 300);
					toggleButton.classList.add('active');
				}
			});
		});
	}
};